import React, { useState, useEffect } from "react";
import "@rainbow-me/rainbowkit/styles.css";
import { ConnectButton } from "@rainbow-me/rainbowkit";

export const UniswapHistory: React.FC = () => {
  const [account, setAccount] = useState<string | null>(null);
  return <ConnectButton accountStatus="avatar" />;
};
